import { LangProps, TPAComponentProps } from '../../types';

export enum TextTypography {
  largeTitle = 'largeTitle',
  smallTitle = 'smallTitle',
  listText = 'listText',
  runningText = 'runningText',
}

export enum TextPriority {
  primary = 'primary',
  secondary = 'secondary',
}

export interface TextProps
  extends React.AriaAttributes,
    TPAComponentProps,
    LangProps {
  /**
   * Set typography preset to be used
   */
  typography?: TextTypography;
  /**
   * Set text priority
   */
  priority?: TextPriority;
  /**
   * Define what tag will be rendered
   */
  children?: React.ReactNode;
  tagName?: string;
  className?: string;
  role?: string;
  id?: string;
}
